import PropTypes from 'prop-types';
import React from 'react';

import CardList from '../../components/cards/CardList';
import ComposableCardListSterBanner from './ComposableCardListSterBanner';
import ComposableShowMoreButton from './ComposableShowMoreButton';
import createComposableHeading from './createComposableHeading';
import VIEW_TYPES from './enum/cardListViewTypes';
import getComponentByType from './getComponentByType';

const ComposableCardList = ({
  contentType,
  viewType,
  title,
  items,
  hasNextPage,
  readMoreButtonText,
  banner,
}) => (
  <CardList
    viewType={viewType}
    items={items}
    title={title}
    hasNextPage={hasNextPage}
    banner={
      banner &&
      banner.sterSiteId && (
        <ComposableCardListSterBanner
          key="banner"
          bannerType={banner.bannerType}
          sterSiteId={banner.sterSiteId}
        />
      )
    }
    renderHeading={createComposableHeading(title)}
    renderCard={getComponentByType(contentType, viewType)}
    renderShowMoreButton={() => (
      <ComposableShowMoreButton label={readMoreButtonText} type={contentType} />
    )}
  />
);

ComposableCardList.defaultProps = {
  viewType: VIEW_TYPES.default,
  readMoreButtonText: null,
  items: [],
  title: null,
  hasNextPage: false,
  banner: null,
};

ComposableCardList.propTypes = {
  contentType: PropTypes.string.isRequired,
  viewType: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  title: PropTypes.string,
  readMoreButtonText: PropTypes.string,
  hasNextPage: PropTypes.bool,
  banner: PropTypes.shape({
    bannerType: PropTypes.oneOf(['homepage', 'artikelen', 'overig']).isRequired,
    sterSiteId: PropTypes.string,
  }),
};

export default ComposableCardList;
